import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { GroupService } from '../../../services/group.service';
import { AlphaSharedModule, PrimeNGModules } from '../../../shared/alpha-shared.module';

@Component({
    selector: 'app-create-group',
    standalone: true,
    imports: [AlphaSharedModule, ...PrimeNGModules, TranslatePipe],
    templateUrl: './create-group.component.html',
})
export class CreateGroupComponent {
    private groupService = inject(GroupService);
    private message = inject(MessageService);
    private fb = inject(FormBuilder);

    data: { [key: string]: any } | null = null;
    title: string = 'default-cm-addGroup';
    groupForm!: FormGroup;

    ngOnInit() {
        this.initializeGroupForm();
        this.data = history?.state?.data;
        if (this.data) {
            this.groupForm.patchValue({
                groupName: this.data['group_name'],
                groupDescription: this.data['description'],
            });
            this.title = 'default-cm-update';
        }
    }

    private initializeGroupForm(): void {
        this.groupForm = this.fb.group({
            groupName: ['', [Validators.required, Validators.maxLength(255)]],
            groupDescription: ['', [Validators.maxLength(255)]],
        });
    }

    get groupName() {
        return this.groupForm.get('groupName') as FormArray;
    }

    get groupDescription() {
        return this.groupForm.get('groupDescription') as FormArray;
    }

    navigateToGroupTable() {
        this.groupService.navigateTo(['home', 'groups']);
    }

    createNewGroup() {
        if (this.groupForm.valid) {
            let errorMessages: string;
            if (this.data) {
                this.groupService
                    .updateGroup(this.data?.['id'], this.groupName?.value, this.groupDescription?.value)
                    .then((data) => {
                        this.message.add({
                            severity: 'success',
                            summary: 'Success!',
                            detail: 'Group Updated Successfully',
                        });
                        this.navigateToGroupTable();
                    })
                    .catch((error) => {
                        errorMessages = error?.error?.stack?.message || 'Failed to update the group';
                        this.message.add({ severity: 'error', summary: 'Failed!', detail: errorMessages });
                    });
            } else {
                this.groupService
                    .createNewGroup(this.groupName?.value, this.groupDescription?.value)
                    .then((data) => {
                        this.message.add({
                            severity: 'success',
                            summary: 'Success!',
                            detail: 'Group Added Successfully',
                        });
                        this.navigateToGroupTable();
                    })
                    .catch((error) => {
                        errorMessages = error?.error?.stack?.message || 'Failed to add the group';
                        this.message.add({ severity: 'error', summary: 'Failed!', detail: errorMessages });
                    });
            }
        }
    }
}
